export enum Environment {
	PROD = "PROD",
	DEV = "DEV",
	LOCAL = "LOCAL",
	TEST = "TEST",
	SIMULATOR = "SIMULATOR"
}
